//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AppContent from '@nextcloud/vue/dist/Components/AppContent';
import AppNavigation from '@nextcloud/vue/dist/Components/AppNavigation';
import AppNavigationCounter from '@nextcloud/vue/dist/Components/AppNavigationCounter';
import AppNavigationItem from '@nextcloud/vue/dist/Components/AppNavigationItem';
import AppNavigationSpacer from '@nextcloud/vue/dist/Components/AppNavigationSpacer';
import AppSidebar from '@nextcloud/vue/dist/Components/AppSidebar';
import Content from '@nextcloud/vue/dist/Components/Content';
import Vue from 'vue';
import VueLocalStorage from 'vue-localstorage';
import AppList from '../components/AppList';
import AppDetails from '../components/AppDetails';
Vue.use(VueLocalStorage);
export default {
  name: 'Apps',
  components: {
    AppContent: AppContent,
    AppDetails: AppDetails,
    AppList: AppList,
    AppNavigation: AppNavigation,
    AppNavigationCounter: AppNavigationCounter,
    AppNavigationItem: AppNavigationItem,
    AppNavigationSpacer: AppNavigationSpacer,
    AppSidebar: AppSidebar,
    Content: Content
  },
  props: {
    category: {
      type: String,
      default: 'installed'
    },
    id: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      searchQuery: ''
    };
  },
  computed: {
    loading: function loading() {
      return this.$store.getters.loading('categories');
    },
    loadingList: function loadingList() {
      return this.$store.getters.loading('list');
    },
    currentApp: function currentApp() {
      var _this = this;

      return this.apps.find(function (app) {
        return app.id === _this.id;
      });
    },
    categories: function categories() {
      return this.$store.getters.getCategories;
    },
    apps: function apps() {
      return this.$store.getters.getAllApps;
    },
    updateCount: function updateCount() {
      return this.$store.getters.getUpdateCount;
    },
    settings: function settings() {
      return this.$store.getters.getServerData;
    }
  },
  watch: {
    category: function category(val, old) {
      this.setSearch('');
    }
  },
  beforeMount: function beforeMount() {
    this.$store.dispatch('getCategories');
    this.$store.dispatch('getAllApps');
    this.$store.dispatch('getGroups', {
      offset: 0,
      limit: 5
    });
    this.$store.commit('setUpdateCount', this.$store.getters.getServerData.updateCount);
  },
  mounted: function mounted() {
    /**
     * Register search
     */
    this.appSearch = new OCA.Search(this.setSearch, this.resetSearch);
  },
  methods: {
    setSearch: function setSearch(query) {
      this.searchQuery = query;
    },
    resetSearch: function resetSearch() {
      this.setSearch('');
    },
    hideAppDetails: function hideAppDetails() {
      this.$router.push({
        name: 'apps-category',
        params: {
          category: this.category
        }
      });
    }
  }
};